export enum INTELEX_SUPPLIER_AUDIT_FE_BE_MAPPING_FIELD {
    id = 'id',
    reqType = 'reqType',
    supCompany = 'supCompany',
    supContactName = 'supContactName',
    supContactSso = 'supContactSso',
    supEmail = 'supEmail',
    business = 'business',
    gslNumber = 'gslNumber',
    siteCode = 'siteCode',
    sqeName = 'sqeName',
    jobTitle = 'jobTitle',
    phone = 'phone',
    extension = 'extension',
    detail = 'detail'
}

export class IntelexSupplierAudit {
    id: number;
    reqType: string;
    supCompany: string;
    supContactName: string;
    supContactSso: string;
    supEmail: string;
    business: any;
    gslNumber: string;
    siteCode: string;
    sqeName: string;
    jobTitle: string;
    phone: string;
    extension: string;    
    detail: string;    

    constructor(params: any = {}, parsed: boolean = true, SQEsso?) {
        if (parsed) {
            this.parseFromResp(params);
        } else {
            this.id = params.id;
            this.reqType = params.reqType;
            this.supCompany = params.supCompany;
            this.supContactName = params.supContactName;
            this.supContactSso = params.supContactSso;
            this.supEmail = params.supEmail;
            this.business = params.business;
            this.gslNumber = params.gslNumber;
            this.siteCode = params.siteCode;
            this.sqeName = SQEsso ? SQEsso : params.SQEName;
            this.jobTitle = params.jobTitle;
            this.phone = params.phone;
            this.extension = params.extension;
            this.detail = params.detail;
        }
    }

    parseFromResp(respObject: any = {}) {
        this.id = respObject[INTELEX_SUPPLIER_AUDIT_FE_BE_MAPPING_FIELD.id];
        this.reqType = respObject[INTELEX_SUPPLIER_AUDIT_FE_BE_MAPPING_FIELD.reqType];
        this.supCompany = respObject[INTELEX_SUPPLIER_AUDIT_FE_BE_MAPPING_FIELD.supCompany];
        this.supContactName = respObject[INTELEX_SUPPLIER_AUDIT_FE_BE_MAPPING_FIELD.supContactName];
        this.supContactSso = respObject[INTELEX_SUPPLIER_AUDIT_FE_BE_MAPPING_FIELD.supContactSso];
        this.supEmail = respObject[INTELEX_SUPPLIER_AUDIT_FE_BE_MAPPING_FIELD.supEmail];
        this.business = respObject[INTELEX_SUPPLIER_AUDIT_FE_BE_MAPPING_FIELD.business];
        this.gslNumber = respObject[INTELEX_SUPPLIER_AUDIT_FE_BE_MAPPING_FIELD.gslNumber];
        this.siteCode = respObject[INTELEX_SUPPLIER_AUDIT_FE_BE_MAPPING_FIELD.siteCode];
        this.sqeName = respObject[INTELEX_SUPPLIER_AUDIT_FE_BE_MAPPING_FIELD.sqeName];
        this.jobTitle = respObject[INTELEX_SUPPLIER_AUDIT_FE_BE_MAPPING_FIELD.jobTitle];
        this.phone = respObject[INTELEX_SUPPLIER_AUDIT_FE_BE_MAPPING_FIELD.phone];
        this.extension = respObject[INTELEX_SUPPLIER_AUDIT_FE_BE_MAPPING_FIELD.extension];
        this.detail = respObject[INTELEX_SUPPLIER_AUDIT_FE_BE_MAPPING_FIELD.detail];
        return this;
    }

    convertToReqBody() {
        const body = {};
        body[INTELEX_SUPPLIER_AUDIT_FE_BE_MAPPING_FIELD.id] = this.id;
        body[INTELEX_SUPPLIER_AUDIT_FE_BE_MAPPING_FIELD.reqType] = this.reqType;
        body[INTELEX_SUPPLIER_AUDIT_FE_BE_MAPPING_FIELD.supCompany] = this.supCompany;
        body[INTELEX_SUPPLIER_AUDIT_FE_BE_MAPPING_FIELD.supContactName] = this.supContactName;
        body[INTELEX_SUPPLIER_AUDIT_FE_BE_MAPPING_FIELD.supContactSso] = this.supContactSso;
        body[INTELEX_SUPPLIER_AUDIT_FE_BE_MAPPING_FIELD.supEmail] = this.supEmail;
        body[INTELEX_SUPPLIER_AUDIT_FE_BE_MAPPING_FIELD.business] = this.business.name;
        body[INTELEX_SUPPLIER_AUDIT_FE_BE_MAPPING_FIELD.gslNumber] = this.gslNumber;
        body[INTELEX_SUPPLIER_AUDIT_FE_BE_MAPPING_FIELD.siteCode] = this.siteCode;
        body[INTELEX_SUPPLIER_AUDIT_FE_BE_MAPPING_FIELD.sqeName] = this.sqeName;
        body[INTELEX_SUPPLIER_AUDIT_FE_BE_MAPPING_FIELD.jobTitle] = this.jobTitle || '';
        body[INTELEX_SUPPLIER_AUDIT_FE_BE_MAPPING_FIELD.phone] = this.phone || '';
        body[INTELEX_SUPPLIER_AUDIT_FE_BE_MAPPING_FIELD.extension] = this.extension || '';
        body[INTELEX_SUPPLIER_AUDIT_FE_BE_MAPPING_FIELD.detail] = this.detail || '';
        return body;
    }
}